import { configureStore } from '@reduxjs/toolkit'
import { SearchFilterReducer } from '../reducer/searchFilterReducer'

const sfstore = configureStore({ reducer: SearchFilterReducer })

export default sfstore
